import { UPDATE_TASK_TYPE_FAILURE, UPDATE_TASK_TYPE_REQUEST, UPDATE_TASK_TYPE_SUCCESS } from "../actionTypes"

interface updateTaskTypeState {
    loading  : boolean,
    updatedTaskTypeData : any,
    error : string
}

interface action {
    type : string
    payload : any
}

const initialState:updateTaskTypeState = {
    loading  : false,
    updatedTaskTypeData : {},
    error : ""
}

export const updateTaskTypeReducer = (state = initialState, action : action) => {
    switch(action.type){
        case UPDATE_TASK_TYPE_REQUEST : return {
            loading : true
        }
        case UPDATE_TASK_TYPE_SUCCESS : return {
            loading : false,
            updatedTaskTypeData : action.payload,
            error : ""
        }
        case UPDATE_TASK_TYPE_FAILURE : return {
            loading : false,
            updatedTaskTypeData : {},
            error : action.payload
        }
        default : return state
    }
}